export default "<h3>June 1, 2020</h3>\r\n<p>Version 1.82 fixes some bugs.</p>";